import HTTP from "./http.service";
import Moment from "moment";

var TimeService = {};

TimeService.getCurrentTimestamp = () => {
  let config = {
    method: "get",
    url: "/me/current_timestamp"
  };
  return HTTP(config);
};

TimeService.subtract = (amount, unit, target) => {
  return target.subtract(amount, unit);
};

TimeService.getTimeLeft = (time1, time2, unit = "minutes") => {
  // let time_zone_offset = time1.diff(time3, "hours");

  let diff = time2.diff(time1, "minutes");

  let total_diff = parseFloat(diff); // + parseFloat(time_zone_offset);

  if (unit === "hours") {
    return total_diff / 60;
  }

  if (unit === "seconds") {
    return total_diff * 60;
  }

  return total_diff;
};

TimeService.timeToHumanString = (value, unit = "seconds") => {
  let time = parseFloat(value);
  let result = "";

  if (time <= 0) {
    return result;
  }

  // convert to seconds
  if (unit === "hours") {
    time = time * 60 * 60;
  }
  if (unit === "minutes") {
    time = time * 60;
  }

  let hours = Math.floor(time / 60 / 60);
  let minutes = Math.floor((time / 60) % 60);
  let seconds = Math.floor(time % 60);

  if (hours) {
    result += hours + " hour" + (hours > 1 ? "s" : "") + " ";
  }
  if (minutes) {
    result += minutes + " minute" + (minutes > 1 ? "s" : "") + " ";
  }
  if (seconds) {
    result += seconds + " second" + (seconds > 1 ? "s" : "");
  }

  return result;
};

TimeService.timeWithinRange = (from, to, current) => {
  // from = Moment(from, "DD-MM-YYYY HH:mm:ss") ;
  // to = Moment(to, "DD-MM-YYYY HH:mm:ss") ;
  // current = Moment(current, "DD-MM-YYYY HH:mm:ss") ;

  // if delivery end date was 00:00 use next day in comparision:
  if(to.format("HH:mm") === '00:00') to.add(1, 'days');

  return from.isSameOrBefore(current) && to.isAfter(current);
};

TimeService.getTime = (value, format) => {
  if (!value) {
    return Moment();
  }
  return Moment(value, format);
};

TimeService.getTimeFormatted = (value, format, targetFormat) => {
  return Moment(value, format).format(targetFormat);
};

export default TimeService;
